import { Checkbox, FormControlLabel } from '@mui/material'

interface Props {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

export const IncludeCheckbox = ({ label, checked, onChange }: Props) => {
  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox checked={checked} onChange={(_, value) => onChange(value)} />
      }
    />
  )
}
